module.exports = __webpack_public_path__ + "media/images/sp/special_plans/separator_skyblue-1cf55f9ad35b23f30d0875f88501dee8.png";